import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RoleBasedRoutes from './RoleBasedRoutes';
import { useAuth } from './context/AuthContext';
import DynamicBodyClass from './components/DynamicBodyClass';
import ImpersonationBanner from './components/ImpersonationBanner';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
/* Load last so admin mobile menu wins over dashboard-mobile.css (pulled in via customerRoutes bundle). */
import './assets/admin/css/admin-responsive-overrides.css';

function App() { 
    const { user } = useAuth();

    return (
        <Router>
            <DynamicBodyClass />
            <ImpersonationBanner />
            <Routes> 
                <Route path="*" element={<RoleBasedRoutes user={user} />} />
            </Routes>
        </Router>
    );
}

export default App;
